import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal is-active",
  ref: "transactions"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "modal-background" }, null, -1)
const _hoisted_3 = { class: "modal-card" }
const _hoisted_4 = { class: "modal-card-head" }
const _hoisted_5 = { class: "modal-card-title is-title-shrink" }
const _hoisted_6 = { class: "ml-2" }
const _hoisted_7 = { class: "modal-card-foot custom-modal-card-foot is-justify-content-end" }
const _hoisted_8 = { class: "dropdown-trigger" }
const _hoisted_9 = ["aria-expanded", "disabled"]
const _hoisted_10 = {
  key: 0,
  class: "icon"
}
const _hoisted_11 = {
  key: 1,
  class: "icon"
}
const _hoisted_12 = { class: "custom-card-related" }
const _hoisted_13 = { class: "icon" }
const _hoisted_14 = { class: "dropdown-content" }
const _hoisted_15 = { class: "dropdown-item is-flex" }
const _hoisted_16 = { class: "icon mr-1" }
const _hoisted_17 = { class: "dropdown-item is-flex" }
const _hoisted_18 = { class: "icon mr-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TransactionList = _resolveComponent("TransactionList")!
  const _component_fa_icon = _resolveComponent("fa-icon")!

  return (_ctx.$modal.modal.value == _ctx.$options.name)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("header", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$gettext("All transactions")), 1)
            ]),
            _createElementVNode("button", {
              class: "delete",
              "aria-label": "close",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$modal.back()))
            })
          ]),
          _createVNode(_component_TransactionList, {
            recipient: _ctx.selectedRecipient,
            account: _ctx.account,
            "show-all": _ctx.showAll,
            ref: "txList"
          }, null, 8, ["recipient", "account", "show-all"]),
          _createElementVNode("footer", _hoisted_7, [
            _createElementVNode("div", {
              class: _normalizeClass(["dropdown is-up transaction-download-dropdown", { 'is-active': _ctx.isDownloadDropdownOpen }]),
              ref: "downloadDropdown"
            }, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("button", {
                  class: "button custom-button-modal has-text-weight-medium transaction-list-download",
                  "aria-haspopup": "true",
                  "aria-controls": "transaction-export-menu",
                  "aria-expanded": _ctx.isDownloadDropdownOpen,
                  onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleDownloadDropdown && _ctx.toggleDownloadDropdown(...args)), ["stop"])),
                  disabled: _ctx.isTransactionsLoading
                }, [
                  (_ctx.isTransactionsLoading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                        _createVNode(_component_fa_icon, {
                          icon: "fa-circle-notch",
                          class: _normalizeClass([{ refreshing: _ctx.isTransactionsLoading }, "fa-lg"])
                        }, null, 8, ["class"])
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_11, [
                        _createVNode(_component_fa_icon, {
                          icon: _ctx.getPlatform === 'web' ? 'fa-download' : 'fa-share',
                          class: "download-icon"
                        }, null, 8, ["icon"])
                      ])),
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.getPlatform === "web" ? _ctx.$gettext("Download") : _ctx.$gettext("Share")), 1),
                  _createElementVNode("span", _hoisted_13, [
                    _createVNode(_component_fa_icon, {
                      icon: 
                    _ctx.isDownloadDropdownOpen ? 'fa-angle-down' : 'fa-angle-up'
                  ,
                      class: "fa-lg"
                    }, null, 8, ["icon"])
                  ])
                ], 8, _hoisted_9)
              ]),
              _createElementVNode("div", {
                class: "dropdown-menu",
                id: "transaction-export-menu",
                role: "menu",
                onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
              }, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("span", _hoisted_15, [
                    _createElementVNode("a", {
                      href: "#",
                      class: "dropdown-item-link",
                      onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (
                    _ctx.getPlatform === 'web' ? _ctx.downloadPdfFile() : _ctx.sharePdfFile()
                  ), ["prevent"]))
                    }, [
                      _createElementVNode("span", _hoisted_16, [
                        _createVNode(_component_fa_icon, {
                          icon: "fa-file-pdf",
                          class: "fa-lg"
                        })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.getPlatform === "web"
                      ? _ctx.$gettext("Download PDF file")
                      : _ctx.$gettext("Share PDF file")), 1)
                    ])
                  ]),
                  _createElementVNode("span", _hoisted_17, [
                    _createElementVNode("a", {
                      href: "#",
                      class: "dropdown-item-link",
                      onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (
                    _ctx.getPlatform === 'web' ? _ctx.downloadCsvFile() : _ctx.shareCsvFile()
                  ), ["prevent"]))
                    }, [
                      _createElementVNode("span", _hoisted_18, [
                        _createVNode(_component_fa_icon, {
                          icon: "fa-file-csv",
                          class: "fa-lg"
                        })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.getPlatform === "web"
                      ? _ctx.$gettext("Download CSV file")
                      : _ctx.$gettext("Share CSV file")), 1)
                    ])
                  ])
                ])
              ])
            ], 2)
          ])
        ])
      ], 512))
    : _createCommentVNode("", true)
}